<template>
    <div class="creditCard">
        <div class="upper" :class="type == 'visa'   || type == 'mastercard' ? type : 'mastercard'">
            <div class="up">
                <img v-if="type === 'visa'" class="visa" src="/assets/img/creditcard/visa.png" alt="visa">
                <img v-else-if="type === 'mastercard'" class="master" src="/assets/img/creditcard/master.png"
                     alt="master">
                <!--<img v-else class="master" src="/assets/img/creditcard/master.png" alt="master">-->
                <div v-else class="card-type">{{type}}</div>
                <img @click="openModal = true" class="close" src="/assets/img/creditcard/delete_card.png" alt="delete">
                <transition name="fade">
                    <Modal
                        v-if="openModal"
                        @close="openModal = false"
                        width="250px"
                    >
                        <div class="cardModalWrap">
							{{'components/settings/credit-card.are-you-sure' | trans}}
                            <div class="buttons">
                                <PulseLoader v-if="modalLoading" size="8px" color="#00B2FF"/>
                                <div v-else>
                                    <button @click="removeCard" class="btn">{{'components/settings/credit-card.yes' | trans}}</button>
                                    <button @click="openModal = false" class="btnThree">{{'components/settings/credit-card.cancel' | trans}}</button>
                                </div>

                            </div>
                        </div>
                    </Modal>
                </transition>
            </div>
            <div class="down" v-if="!showCardAddress">
                <span class="block title">{{'components/settings/credit-card.card-number' | trans}}:</span>
                <span class="block number">{{ number }}</span>
            </div>
            <div class="down" v-else>
                <span class="block title">{{'components/settings/credit-card.billing-address' | trans}}:</span>
                <span class="block address">{{ address.fullAddress }}</span>
            </div>
        </div>
        <div class="bottom">
            <span class="title">{{'components/settings/credit-card.use-card-for-future-payments' | trans}}</span>

            <PulseLoader v-if="cardLoading" size="8px" color="#00B2FF"/>
            <Switcher v-else v-model="futurePayments" @input="changeCardActivity"/>
            <div class="notification pointer" @mouseover="showCardAddress=true" @mouseleave="showCardAddress=false">
                <img src="/assets/img/info.svg">
            </div>
        </div>

    </div>
</template>

<script>
    import Modal from '../../plugins/Modal';
    import Switcher from '../form/Switcher';
    import {mapActions, mapState} from 'vuex';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        props: ['paymentMethodId', 'cardId', 'number', 'forFuturePayments', 'type', 'status', 'address'],
        data() {
            return {
                futurePayments: false,
                test: false,
                openModal: false,
                modalLoading: false,
                showCardAddress: false,
                cardLoading: false
            }
        },
        components: {
            Switcher, Modal, PulseLoader
        },
        methods: {
            ...mapActions(['setActiveCard', 'setNotActiveCard', 'getUserInfo', 'setRevokedCard', 'addMessage']),
            removeCard: function () {
                this.modalLoading = true;
                this.setRevokedCard(this.paymentMethodId)
                    .then(response => this.getUserInfo().then(r => {
                        this.futurePayments = this.forFuturePayments;
                        return response;
                    }))
                    .then(response=>this.addMessage(response.data.messages))
                    .catch(error => console.log(error))
                    .finally(() => {
                        this.modalLoading = false;
                        this.openModal = false;
                    });
            },
            changeCardActivity: async function () {
                let response;
                this.$emit('setCardActivityLoading', true);
                this.cardLoading = true;

                if (this.futurePayments) {
                    response = await this.setActiveCard(this.paymentMethodId);
                } else {
                    response = await this.setNotActiveCard(this.paymentMethodId);
                }
                await this.getUserInfo();
                this.addMessage(response.data.messages);
                this.$emit('setCardActivityLoading', false);
                this.cardLoading = false;
            }
        },
        watch: {
            forFuturePayments: function (newValue, oldValue) {
                this.futurePayments = newValue;
            }
        }
        ,
        computed: {
            ...mapState(['userInfoLoading'])
        }
        ,
        created: function () {
            this.futurePayments = this.forFuturePayments;
        }
    }
</script>

<style scoped>
    .card-type {
        color: white;
        font-size: 20px;
    }

    .pointer {
        cursor: pointer;
    }

    .block.address {
        font-size: 12px;
        white-space: pre;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: 600;
        color: white;
    }
</style>
